import React from "react";
import FeaturedText from "./FeaturedText";

const FeaturedProject = ({ content, link, repo, image, imageDetails }) => {
  return (
    <div className="project">
      <FeaturedText
        title={content.title}
        link={link}
        repo={repo}
        desc={content.desc}
        techStack={content.techStack}
      />

      <div className="project__image">
        <a href={link} target="_blank" rel="noopener noreferrer">
          <div className="image__wrapper">
            <img
              aria-hidden="true"
              src={image}
              alt={imageDetails ? imageDetails.alt : ""}
            />
          </div>
        </a>
      </div>
    </div>
  );
};

export default FeaturedProject;
